// Project
import request from "../request";
import { publicApiHostName } from "../../Utils/getPublicApiHost";
import { auditLogAction } from "./auditLog";

export const getEmailToken = async (env, userID) => {
	const response = await request({
		url: `/${env}/emailUpdate/${userID}/`,
	});

	return response.data;
};

export const approveEmailChange = async (props) => {
	const { data, env } = props;
	const hostName = await publicApiHostName(env);

	const req = await request({
		url: `${hostName}/api/public/reset-email/`,
		method: "POST",
		data: {
			token: data.token,
			user_id: data.user_id,
		},
	});

	const metadata = {
		employee_id: data.user_id,
		updated_email: data.updated_email,
	};
	await auditLogAction(env, "APPROVE_EMAIL_CHANGE", metadata);
	return req.data;
};
